import { FormattedMessage } from 'react-intl';
import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { AnalyticsHelpers } from '../../analytics.helpers';
import { TooltipForTrimmedText } from '../../../common/components/tooltip-for-trimmed-text/tooltip-for-trimmed-text';
import { Pagination } from '../../../../components/pagination';
import { getMeetingHistory } from '../../../../store/features/meeting-history';
import { selectUser } from '../../../../store/features/system';
import { isLocationsAvailable } from '../../../../modules/core';
export const MeetingHistoryTable = ({ onPageChange, currentPage, limit, }) => {
    const cn = AnalyticsHelpers.makeMeetingHistoryClass('block');
    const data = useSelector(getMeetingHistory);
    const user = useSelector(selectUser);
    const isUserInstitutionOwner = user.institutionsMemberships.some((membership) => membership.role === 'owner');
    const isUserInstitutionAdmin = user.institutionsMemberships.some((membership) => membership.role === 'admin');
    const isLocationsEnabled = isLocationsAvailable();
    let hideRoomInfo = false;
    let hideProviderInfo = false;
    if (user.subscriptionType === 'pro' || user.subscriptionType === 'free') {
        hideRoomInfo = true;
        hideProviderInfo = true;
    }
    if (!isUserInstitutionOwner && !isUserInstitutionAdmin) {
        hideProviderInfo = true;
    }
    const noData = () => {
        return (<a href="https://help.doxy.me/en/articles/2312691-meeting-history-is-missing" rel="noreferrer" target="_blank">
        <FormattedMessage id="account.meeting-history.no-data"/>
      </a>);
    };
    return (<div className={cn('content-wrapper')}>
      <table className={classnames(['table', cn('table')])}>
        <thead>
          <tr>
            <th className={cn('date-column')}>
              <FormattedMessage id="account.meeting-history.date"/>
            </th>
            {!hideProviderInfo && (<th className={cn('provider-column')}>
                <FormattedMessage id="account.meeting-history.provider"/>
              </th>)}
            {!hideRoomInfo && (<th className={cn('slug-column')}>
                <FormattedMessage id="account.meeting-history.room"/>
              </th>)}
            {isLocationsEnabled &&
            (isUserInstitutionAdmin || isUserInstitutionOwner) && (<th className={cn('location-column')}>
                  <FormattedMessage id="account.settings.manage-users.table.location"/>
                </th>)}
            <th className={cn('time-columns')}>
              <FormattedMessage id="account.meeting-history.start"/>
            </th>
            <th className={cn('time-columns')}>
              <FormattedMessage id="account.meeting-history.end"/>
            </th>
            <th className={cn('time-columns')}>
              <FormattedMessage id="account.meeting-history.duration"/>
            </th>
          </tr>
        </thead>
        <tbody className={cn('table-body')}>
          {data.callSessions.map((item) => {
            return (<tr key={item.id}>
                <td className={cn('date-column')}>
                  {AnalyticsHelpers.rawDataToDate(item.created)}
                </td>
                {!hideProviderInfo && (<td className={cn('provider-column')}>
                    <TooltipForTrimmedText value={`${item.firstName} ${item.lastName}`}/>
                  </td>)}
                {!hideRoomInfo && (<td className={cn('slug-column')}>
                    <TooltipForTrimmedText value={`/${item.slug}`}/>
                  </td>)}
                {isLocationsEnabled &&
                    (isUserInstitutionAdmin || isUserInstitutionOwner) && (<td className={cn('location-column')}>
                      {Boolean(item.location) ? (<TooltipForTrimmedText value={item.location.name}/>) : (<FormattedMessage id="account.meeting-history.no-data"/>)}
                    </td>)}
                <td className={cn('time-columns')}>
                  {Boolean(item.created)
                    ? AnalyticsHelpers.rawDataToStartTime(item.created)
                    : noData()}
                </td>
                <td className={cn('time-columns')}>
                  {Boolean(item.endTime)
                    ? AnalyticsHelpers.rawDataToStartTime(item.endTime)
                    : noData()}
                </td>
                <td className={cn('time-columns')}>
                  {Boolean(item.duration) ? (<span className={cn('decimal')}>
                      {AnalyticsHelpers.millisToMinutesWithoutLeadZeroAndSeconds(item.duration)}
                    </span>) : (noData())}
                </td>
              </tr>);
        })}
        </tbody>
      </table>
      <Pagination totalItems={data.total} limitPerPage={limit} currentPage={currentPage} onChange={onPageChange}/>
    </div>);
};
